<div class="dynamic-section">
    <div class="dynamic-header">
        <div class="dh-left">
            <span class="s-icon">👫</span>
            <h3>Siblings</h3>
        </div>
        <button (click)="add.emit()" class="btn-add" type="button">+ Add Sibling</button>
    </div>

    @for (s of formArray.controls; track $index) {
        <div [formGroup]="asFormGroup(s)" class="item-card">
            <div class="row g-3">
                <div class="col-md-2">
                    <div class="field">
                        <label class="field-label">SIN <span class="req">*</span></label>
                        <input class="f-input" formControlName="sin_number" placeholder="SIN">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="field">
                        <label class="field-label">First Name <span class="req">*</span></label>
                        <input class="f-input" formControlName="first_name" placeholder="First name">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="field">
                        <label class="field-label">Middle Name</label>
                        <input class="f-input" formControlName="middle_name" placeholder="Middle name">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="field">
                        <label class="field-label">Last Name <span class="req">*</span></label>
                        <input class="f-input" formControlName="last_name" placeholder="Last name">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="field">
                        <label class="field-label">Relation <span class="req">*</span></label>
                        <select class="f-select" formControlName="relation_id">
                            <option value="">Select Relation</option>
                            @for (item of siblingRelationType; track item.value) {
                                <option [value]="item.value">{{ item.label }}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="field">
                        <label class="field-label">Course <span class="req">*</span></label>
                        <select class="f-select" formControlName="course_id">
                            <option value="">Select Course</option>
                            @for (c of allCourses; track c.course_name) {
                                <option [value]="c.id">{{ c.course_name }}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="col-12 d-flex justify-content-end">
                    <button (click)="remove.emit($index)" class="btn-remove" type="button">✕ Remove</button>
                </div>
            </div>
        </div>
    } @empty {
        <div class="empty-state">No siblings added. Click <strong>+ Add Sibling</strong> to add one.</div>
    }
</div>
